/**
 * Portail state router
 * @param $stateProvider
 */
function stateRouter($stateProvider) {
    $stateProvider.state('documentation', {
        data: {
            title: 'Espace Documentaire'
        },
        url         : '/portail/documentations',
        template    : require('./partials/documentation.html'),
        controller  : 'DocumentationCtrl',
        controllerAs: 'documentationCtrl',
        resolve     : {
            categories: function (documentationService, authService) {
                return documentationService.fetchCategories(authService.getAuthInfos());
            }
        }
    });
}

angular.module('app.portail.documentation', []).config(stateRouter);

require('./controllers/documentationCtrl');
require('./services/documentationService');
